






































import {Component, Mixins, Prop, Vue, Watch} from "vue-property-decorator";
import appState, {Target} from '@/store/app';
import Const from '@/mixins/Const.ts';

@Component
export default class ProductForm extends Mixins(Const) {
  @Prop({ required: true }) value!: Target;
  @Prop({ default: false }) deletable!: boolean;
  @Prop({ default: 'md' }) size!: 'sm' | 'md' | 'lg';

  get tp() { return appState.tp; }
  get tt() { return appState.t; }
  get products() { return appState.products; }

  get productPrice() { return (prodId: number): number => Math.round(appState.productPrice(prodId)); }

  updateTarget(field: string, value: any) {
    this.$emit('input', {
        ...this.value, [field]: value,
    })
  }
}
